import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.metal
};
export default anchor;